<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1>SMS Configuration</h1>
        <v-divider class="py-3"></v-divider>
        <p>Configure the SMS settings for employees. These settings are used by the SMS Broadcast service and the Group Text System (on the Operations Hub). Intructors have class type options so that they can be filtered by other instructors when looking for a substitute. Front Desk and Studio Managers can only be enabled or disabled as they can only be contacted through the <router-link :to="{ name: 'SMSBroadcastRoute' }">SMS Broadcast service</router-link> here on Ecco.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4">
          <v-col cols="12">
            <v-tabs>
              <v-tab exact :to="{ name: 'InstructorTableRoute' }">Instructors</v-tab>
              <v-tab exact :to="{ name: 'FrontDeskTableRoute' }">Front Desk</v-tab>
              <v-tab exact :to="{ name: 'StudioManagerTableRoute' }">Studio Managers</v-tab>
            </v-tabs>
          </v-col>

          <v-row>
            <router-view></router-view>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EmployeesPage',

  data() {
    return {
    }
  },

  computed: {
  },

}
</script>

<style lang="scss">

</style>